import { AuthApiClient } from "@/features/auth/api-client/api-client";
import { isTooManyRequestsReponse, type CheckEmailExistsResponse } from "@/features/auth/types";
import useCaptchaVerify from "@/features/utils/hooks/use_captcha_verify";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export default function useCheckEmailExistsMutation(
  options?: UseMutationOptions<CheckEmailExistsResponse, Error, { email: string; uuid?: string }>
) {
  const { handleReCaptchaVerify } = useCaptchaVerify();
  const { t } = useTranslation(["pass"]);

  return useMutation<CheckEmailExistsResponse, Error, { email: string; uuid?: string }>({
    mutationFn: async (body: { email: string; uuid?: string }) => {
      const token = await handleReCaptchaVerify();
      const data = await AuthApiClient.checkExistingEmail(body, token);
      if (isTooManyRequestsReponse(data))
        throw new Error(t("flow.id_control.error.check_email_exist_rate_limit"));
      if (data.status !== 200)
        throw new Error(t("flow.id_control.error.error_check_existing_email"));
      return data.data;
    },
    ...options
  });
}
